import clsx from 'clsx';
import HubertInput from 'components/HubertUI/HubertInput';
import HubertLabel from 'components/HubertUI/HubertLabel';
import MutedText from 'components/common/MutedText';
import { useQuestionEditorContext } from '../context/create-question.context';

import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionDescription, selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateShortDescription } from 'rtk/Question.Editor.Slice';
import { useInTemplateEditAndUneditable } from 'hooks/useInTemplateEditAndUneditable';
import { useTranslation } from 'react-i18next';

const AliasInput = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionDescription = useAppSelector((state) => selectQuestionDescription(state, questionId));
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const inTemplateEditAndUneditable = useInTemplateEditAndUneditable(questionId, mode);

  return (
    <div className={clsx(inTemplateEditAndUneditable && 'hidden', 'flex flex-col justify-start gap-4', 'p-1')}>
      <div
        className={clsx(
          inTemplateEditAndUneditable && 'hidden',
          'flex flex-row justify-start gap-4',
          'hubert-vertical-center',
        )}
      >
        <HubertLabel htmlFor="create-question-alias">{t('aliasInput.label')}</HubertLabel>
        <HubertInput
          id="create-question-alias"
          value={questionDescription}
          placeholder={t('aliasInput.placeholder')}
          onChange={(e) => {
            dispatch(updateShortDescription({ questionId, description: e.target.value }));
          }}
        />
      </div>
      <div className="">
        <MutedText text={t('aliasInput.hint')} />
      </div>
    </div>
  );
};

export default AliasInput;
